import { databaseAddFormActions } from '../actions'
import { TABLE_FIELDS } from '../constants'
import { getReferenceTables } from '../utils/tableHelpers'
import { useActions, useAppSelector } from '../../../store/hooks'
import { databasePageSelector } from '../../../store/slices/databasePage'
import { databaseSelector } from '../../../store/slices/database'

export function useDatabaseAddForm() {
    const selectedTable = useAppSelector(databasePageSelector.selectedTable)
    const formData = useAppSelector(databasePageSelector.formData)
    const referenceOptions = useAppSelector(databaseSelector.referenceOptions)
    const referencesLoading = useAppSelector(databaseSelector.referencesLoading)
    const adding = useAppSelector(databaseSelector.adding)
    const addError = useAppSelector(databaseSelector.addError)

    const { updateFormField, databaseCreateRow } = useActions(databaseAddFormActions)

    const currentFields = TABLE_FIELDS[selectedTable] || {}

    const handleFieldChange = (field, value) => {
        updateFormField({ field, value })
    }

    const handleSubmit = (event) => {
        event.preventDefault()

        databaseCreateRow({
            table: selectedTable,
            data: formData,
            referenceTables: getReferenceTables(selectedTable),
        })
    }

    return {
        selectedTable,
        formData,
        currentFields,
        referenceOptions,
        referencesLoading,
        adding,
        addError,
        handleFieldChange,
        handleSubmit,
    }
}
